// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-sEz","left":"styles_left__22Xyt","desktopActions":"styles_desktopActions__2eSdL","title":"styles_title__6Q-WG"};